import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { ConstantMan } from '../../../../core/services/constantMan';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss'],
})
export class RoleComponent implements OnInit, OnDestroy, ContainsSubscriptions {
  subs: Subscription[] = [];
  public columnDefs;
  public rowData;
  public editPath;

  constructor(
    private router: Router,
    private roleDAO: RoleDAO,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);

    const roleSub = this.roleDAO.get().subscribe((roles) => {
      this.rowData = roles;
      this.editPath = 'manage/admin/role/edit';
      this.columnDefs = this.createColumnDefs();
    });
    this.subs.push(roleSub);
  }

  ngOnInit() {}

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Name',
        field: 'type',
        filter: 'text',
      },
      {
        headerName: 'Admin Access',
        field: 'adminAccess',
        filter: 'text',
      },
    ];
  }
}
